import { HStack, Skeleton, SkeletonCircle, Tooltip } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import type {
  Brand,
  Project,
  ProjectCategory,
} from "@src/__generated__/urql-graphql";
import { BrandLogo, ButtonLink, Link } from "@src/components/ui-kit";
import { observer } from "mobx-react-lite";
import type { DeepPick } from "ts-essentials";

interface TitleProps {
  project: Pick<Project, "id" | "code" | "numeric_code" | "title"> & {
    categories?: { name: ProjectCategory["name"] }[];
  };
  billable?: boolean;
  brand?: {
    id: Brand["id"];
    name: Brand["name"];
    image?: DeepPick<Brand["image"], { urls: { thumbnail: never } }>;
  };
}

const Title = ({ project, billable, brand }: TitleProps) => {
  return (
    <HStack>
      <Tooltip isDisabled={!brand} label={brand?.name}>
        <span>
          <ButtonLink
            variant="plain"
            href={{ pathname: "/brands/detail", query: { id: brand?.id } }}
            mr="2"
            p="0"
          >
            <SkeletonCircle isLoaded={!!brand} size="8">
              <BrandLogo
                src={brand?.image?.urls?.thumbnail}
                name={brand?.name}
              />
            </SkeletonCircle>
          </ButtonLink>
        </span>
      </Tooltip>
      <Tooltip
        hasArrow
        label={project.title}
        placement="top"
        shouldWrapChildren
      >
        <Link
          href={{ pathname: "/projects/detail", query: { id: project.id } }}
        >
          <Skeleton minH="4" isLoaded={!!project.code}>
            <div>{project.code}</div>
          </Skeleton>
          <Skeleton minH="4" isLoaded={!!project.title}>
            <div className="truncate">{project.title}</div>
          </Skeleton>
        </Link>
        {/*
        <Skeleton minH="4" isLoaded={Array.isArray(project.categories)}>
          <HStack wrap="wrap" mt="1">
            {project.categories?.map(({ name }, index) => (
              <Badge
                key={`${name}-${index}`}
                fontSize="2xs"
                fontWeight="thin"
                bg="grey.50"
                size="xs"
              >
                {name}
              </Badge>
            ))}
          </HStack>
        </Skeleton>
        */}
        <div>
          {billable === false && (
            <span className="text-sm text-inkDark ml-1">
              <Trans>(Non-billable)</Trans>
            </span>
          )}
        </div>
      </Tooltip>
    </HStack>
  );
};

export default observer(Title);
